import { PopoverContent } from '@e2n/ui';
import { faCalendarRange, faUser } from '@fortawesome/pro-regular-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Location } from '@/domain/mitarbeiter/features/rotationsplan/components/Location';
import { KalenderByMitarbeiterStation } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByMitarbeiter/KalenderStation';
import { StyleProps } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/station/types';

export function MitarbeiterStationIntervalContent({
  interval,
  onMouseEnter,
  onMouseLeave,
}: {
  interval: KalenderByMitarbeiterStation;
  onMouseEnter: (event: React.MouseEvent) => void;
  onMouseLeave: () => void;
}) {
  const { t } = useTranslation();

  return (
    <>
      <div
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className="w-full h-full bg-(--bg-color) border-(--border-color) border border-solid rounded-md flex items-center justify-start px-2"
        style={
          {
            '--bg-color': interval.arbeitsbereich.getFillColor(),
            '--border-color': interval.arbeitsbereich.getBorderColor(),
          } as StyleProps
        }>
        <div className="text-xs truncate">{interval.arbeitsbereich.name}</div>
      </div>
      <PopoverContent className="bg-white flex flex-col gap-2 p-3 text-sm w-75">
        <div className="flex gap-2 items-center">
          <FontAwesomeIcon
            icon={faCircle}
            color={interval.arbeitsbereich.getBorderColor()}
            className='text-xs'
          />
          <div className="font-semibold">{interval.arbeitsbereich.name}</div>
        </div>
        <Location standort={interval.arbeitsbereich.standort} />
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faCalendarRange} />
            {t('domain.mitarbeiter.rotationsplan.zeitraum')}
          </div>
          <div className="font-semibold">
            {dayjs(interval.station.von).format('DD.MM') +
              ' – ' +
              dayjs(interval.station.bis).format('DD.MM.YYYY')}
          </div>
        </div>
        {interval.station.abteilungsleiter && (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <FontAwesomeIcon icon={faUser} />
              {t('domain.mitarbeiter.rotationsplan.abteilungsleitung')}
            </div>
            <div className="font-semibold">
              {interval.station.abteilungsleiter.vorname +
                ' ' +
                interval.station.abteilungsleiter.nachname}
            </div>
          </div>
        )}
      </PopoverContent>
    </>
  );
}
